const topics = [
  { label: '国产动作片', count: '2.3万', hot: true },
  { label: '悬疑推理', count: '1.8万', hot: true },
  { label: '科幻大片', count: '1.5万', hot: false },
  { label: '爱情电影', count: '2.1万', hot: true },
  { label: '喜剧合集', count: '1.9万', hot: false },
  { label: '纪录片', count: '8.6千', hot: false },
  { label: '动画电影', count: '1.2万', hot: false },
  { label: '战争历史', count: '9.3千', hot: false },
  { label: '恐怖惊悚', count: '1.6万', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm">大家都在讨论的影视话题标签</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topics.map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-2 px-5 py-3 rounded-full bg-background-50 hover:bg-primary-500/10 transition-colors cursor-pointer group border border-background-200/50"
            >
              {item.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500 flex-shrink-0"></span>
              )}
              <span className="text-sm text-foreground-700 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                #{item.label}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}